import mutators from '@/models'

const fields = [
  {
    name: 'Id',
    field: 'id',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'number',
    rules: {
      required: false
    }
  },
  {
    name: 'Código SAP',
    field: 'sap_code',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Código AIM',
    field: 'aim_code',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Código ANF',
    field: 'anf_code',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Código SPMS',
    field: 'spms_code',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Nome Comercial',
    field: 'commercial_name',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Dosagem',
    field: 'dosage',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Forma Farmacêutica',
    field: 'dosage_form',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Nome',
    field: 'name',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Apresentação',
    field: 'presentation',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Condições de Conservação',
    field: 'conservation_conditions',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Preço (unid.)',
    field: 'price_unit',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'number',
    rules: {
      required: false
    }
  },
  {
    name: 'Número de unidades (caixa)',
    field: 'quantity_per_package',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Classificação',
    field: 'classification',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Data de Autorização',
    field: 'authorization_date',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Comercializado',
    field: 'is_marketed',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'boolean',
    rules: {
      required: false
    }
  },
  {
    name: 'Data de Comercialização',
    field: 'marketing_date',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Genérico',
    field: 'is_generic_drug',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'boolean',
    rules: {
      required: false
    }
  },
  {
    name: 'Licença',
    field: 'license',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'TAIM',
    field: 'taim',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 3,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Inserção',
    field: 'created_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Última Atualização',
    field: 'updated_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Eliminação',
    field: 'deleted_at',
    visible: false,
    sortable: false,
    filterable: false,
    type: 'date',
    rules: {
      required: false
    }
  },
]

const rules = mutators.rules(fields)
const empty = mutators.empty(fields)
const filters = mutators.filters(fields)

export default {
  fields,
  rules,
  empty,
  filters
}
